import { render, staticRenderFns } from "./GoogleSlide.vue?vue&type=template&id=81bbe616&scoped=true&"
import script from "./GoogleSlide.vue?vue&type=script&lang=js&"
export * from "./GoogleSlide.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSlide.vue?vue&type=style&index=0&id=81bbe616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bbe616",
  null
  
)

export default component.exports